import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import ReRoute from "./ReRoute";
import { UserProvider } from "../context/UserContext";

const App = () => {
    return (
        <UserProvider>
            <Router>
                <ReRoute />
            </Router>
        </UserProvider>
    );
};

export default App;